import { getSellerSuggestionsForLeadTypes } from './api';
import BuyerApi from '../../helpers/buyer-api';
import ListHtmlBuilder from '../../helpers/list-html-builder';
import { tracking as barkTrackingLogEvent, _t } from '@bark/bark-core';
import MarketplaceRequestQuoteUpsellModal from './marketplace-request-quote-upsell';

export default function () {
	const { QS } = window;
	const sellerHtmlBuilder = ListHtmlBuilder();
	const buyerApi = BuyerApi();
	const marketplaceRequestQuoteUpsellModal = MarketplaceRequestQuoteUpsellModal();
	let showing = false;
	let recommendedToastShown = false;
	let requestReplyShown = false;

	const init = async (state) => {
		const enquiriesOnlySellersResponse = await getSellerSuggestionsForLeadTypes(
			state?.projectDetail?.id,
			['marketplace', 'booking-request'],
			state?.bpvid,
		);

		if (enquiriesOnlySellersResponse?.data && enquiriesOnlySellersResponse.data.length) {
			state.matches = {
				sellerList: enquiriesOnlySellersResponse.data,
				originalSellerList: enquiriesOnlySellersResponse.data,
				interactedSellers: [],
			};

			try {
				const buyerDetailsResponse = await buyerApi.getSelfPromise();
				state.buyerDetails = buyerDetailsResponse?.data ? buyerDetailsResponse : null;
			} catch (e) {
				bugsnagClient && bugsnagClient.notify(new Error(`Failed to get buyer self`));
			}
		}
	};

	const hasData = (state) =>
		!!state?.matches?.sellerList?.length && state?.projectDetail && state?.buyerDetails;

	const renderList = (state) => {
		addStylingTweaks();
		buildHeaderAndFooter(state);
		buildSellerList(state);
		bindListeners(state);
		addTrackingParam();
		triggerHotjar();
	};

	const addStylingTweaks = () => {
		//remove space from top
		$('.page-header .waiting-loader').removeClass('py-5');

		//hide Place new request button on tablet and mobile
		$('#buyer-next-bark').remove();
	};

	const buildHeaderAndFooter = (state) => {
		const { Handlebars } = window;
		const headerTemplate = Handlebars.compile(
			document.getElementById('esl-header-template').innerHTML,
		);
		const footerTemplate = Handlebars.compile(
			document.getElementById('esl-footer-template').innerHTML,
		);
		let hasMarketplace = false;
		let hasBookableSeller = false;
		for (let seller of state.matches.sellerList) {
			if (seller.attributes.match_types.includes('booking-request')) {
				hasBookableSeller = true;
			}
			for (let marketplaceType of [
				'marketplace-enquiry',
				'marketplace-messages',
				'marketplace-booking',
			]) {
				if (seller.attributes.match_types.includes(marketplaceType)) {
					hasMarketplace = true;
				}
			}
		}
		let subTransId = 'enquiries-only';
		if (hasMarketplace && hasBookableSeller) {
			subTransId = 'enquiries-and-bookable';
		} else if (hasBookableSeller) {
			subTransId = 'bookable-only';
		}
		const headerTitle = 'buyer_seller-list:' + subTransId + '.header.title';
		const headerSub = 'buyer_seller-list:' + subTransId + '.header.sub';
		$('#js-esl-header').append(
			headerTemplate({
				title: _t(headerTitle, {
					providerNounPlural: state.projectDetail?.attributes?.provider_noun_plural,
				}),
				sub: _t(headerSub, {
					count: state.matches.sellerList.length,
				}),
			}),
		);
		$('#js-esl-footer').append(
			footerTemplate({
				title: _t('buyer_seller-list:enquiries-only.footer.title', {
					providerNounPlural:
						state.projectDetail?.attributes?.provider_noun_plural.toLowerCase(),
					strong_start: '<strong>',
					strong_end: '</strong>',
					interpolation: { escapeValue: false },
				}),
				seePotentialMatchesButton: _t(
					'buyer_seller-list:enquiries-only.footer.see-potential-matches-button',
				),
				loadMoreProfessionalsButton: _t(
					'buyer_seller-list:enquiries-only.footer.load-more-professionals-button',
				),
			}),
		);
	};

	const buildSellerList = (state) => {
		const sellerRowsHtml = state.matches.sellerList.map((item) => {
			let seller = sellerHtmlBuilder.buildSellerHtml(
				{
					...item,
					linkListType: 'project_sellers',
					projectHash: state.projectDetail?.id,
				},
				state,
				false,
				true,
			);
			let $seller = $(seller);
			$seller.data('sellerData', { ...item.attributes, id: item.id });
			return $seller;
		});
		$('#seller-list').empty().append(sellerRowsHtml);
	};

	const bindListeners = (state) => {
		$('.js-see-potential-matches-cta')
			.off('click.see-potential-matches-cta')
			.on('click.see-potential-matches-cta', function () {
				barkTrackingLogEvent(
					'marketplace-seller-list',
					'see - potential - matches - click',
					{
						buyer_user_id: state?.buyerDetails?.data?.id,
						project_id: state?.projectDetail?.id,
						source: 'list',
					},
				);

				QS.setValue('view', 'full');
				QS.setValue('lt', 'matches');
				QS.setValue('loading-msg', 'loading-professionals');

				location.reload();
			});
	};

	const addTrackingParam = () => QS.setValue('view', 'enquiry');

	const onMarketplaceInteractionComplete = (
		state,
		marketplaceType,
		sellerProfileId,
		meta,
	) => {
		if (
			state?.matches?.interactedSellers &&
			state.matches.interactedSellers.indexOf(sellerProfileId) === -1
		) {
			state.matches.interactedSellers.push(sellerProfileId);
		}

		if (!recommendedToastShown && shouldShowRecommendedToast(state)) {
			recommendedToastShown = true;
			showRecommendedToast(state);
		}

		if (!requestReplyShown && shouldShowRequestReplies(state)) {
			requestReplyShown = true;
			marketplaceRequestQuoteUpsellModal.show(state, marketplaceType, meta);
		}
	};

	const shouldShowRequestReplies = (state) =>
		state?.matches?.sellerList?.length - state?.matches?.interactedSellers?.length === 0;

	const isLastSellerToInteract = (state) =>
		state?.matches?.sellerList?.length - state?.matches?.interactedSellers?.length === 1;

	const shouldShowRecommendedToast = (state) =>
		state?.matches?.sellerList?.length > 1 &&
		state?.matches?.interactedSellers?.length === 1;

	const showRecommendedToast = (state) => {
		try {
			if (window.BuyerCallbacks) {
				barkTrackingLogEvent('marketplace-seller-list', 'recommended-toast-view', {
					project_id: state?.projectDetail?.id,
					buyer_user_id: state?.buyerDetails?.data?.id,
				});
				window.BuyerCallbacks.launchModule(
					'marketplace-list-recommended-toast',
					'__rctMarketplaceListRecommendedToast',
					{},
				);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const isFeatureFlagEnabled = () =>
		document.getElementById('enquiries-sellers-separation-enabled')?.value === '1';

	const isExcludedCategory = (categoryId) => false;

	const isExpandedList = () => QS.getValue('view', null) === 'full';

	const isSeparatedList = () => QS.getValue('view', null) === 'enquiry';

	const isShowing = () => showing;

	const setIsShowing = () => {
		showing = true;
	};

	const triggerHotjar = () => {
		console.log('before Hj trigger: marketplace_seller_separation_list');
		if (isSeparatedList() || isExpandedList()) {
			console.log('before Hj trigger: is on seller expanded or enquiry list page');
			if (window?.hj) {
				window.hj('event', 'marketplace_seller_separation_list');
				console.log('Hotjar event triggered: marketplace_seller_separation_list');
			}
		}
	};

	return {
		init,
		hasData,
		renderList,
		isLastSellerToInteract,
		onMarketplaceInteractionComplete,
		isFeatureFlagEnabled,
		isExpandedList,
		isSeparatedList,
		setIsShowing,
		triggerHotjar,
		isShowing,
		isExcludedCategory,
	};
}
